import React, {Component} from 'react';
import { BrowserRouter as  Router, Link  } from 'react-router-dom';
import { firebaseAuth,ref,storage} from '../../config/constants'
class Sidebar extends Component {
	constructor(){
		super();
        this.generateMenu = this.generateMenu.bind(this);
        this.logOut = this.logOut.bind(this);
        
        this.state = {
            userId : "",
            user : {},
            path : ""
        }


	}
	componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });
                        let image = data.val().image
                        storage.child("Admin").child(image).getDownloadURL().then(function(url){
                            this.setState({
                            path : url
                            })
                        }.bind(this)).catch(function (error){
                            alert(error.code);
                        })
                    }.bind(this));                
            }

        });
       
    }

    logOut(){
        firebaseAuth().signOut();
    }

    generateMenu(menu) {
        if(menu.type == "menu") {
           return <li key={menu.id}><a className="sidebar-nav-menu" href={`/${menu.link}`}><i className={`${menu.icon}`}></i><span className="sidebar-header-title">{menu.label}</span></a></li> 
        }else {
            return <li className="sidebar-header"><div className="sidebar-header sidebar-nav-mini-hide"><span className="sidebar-header-title">{menu.label}</span></div></li>
        }
    }

  	render() {

  			const role = this.state.user.role;
  			
  			const admin=[
                {id:0, type: 'header', label: 'Users'},
                {id:1, type: 'menu',link:'users',label:'View User',icon:'fa fa-users sidebar-nav-icon'},
                {id:2, type: 'menu',link:'users/new',label:'Add User',icon:'fa fa-user sidebar-nav-icon'},
                {id:0, type: 'header', label: 'Products'},
                {id:3, type: 'menu',link:'products',label:'View Products',icon:'fa fa-database sidebar-nav-icon'},
      			{id:4, type: 'menu',link:'products/new',label:'Add Product',icon:'fa fa-folder sidebar-nav-icon'},
                {id:0, type: 'menu',type: 'header', label: 'Product Settings'},
      			{id:5, type: 'menu',link:'category',label:'Category',icon:'fa fa-folder sidebar-nav-icon'},
                {id:6, type: 'menu',link:'unit',label:'Unit',icon:'fa fa-folder sidebar-nav-icon'},
                {id:13, type: 'menu',link:'dimension/new',label:'Add Bended Price',icon:'fa fa-folder sidebar-nav-icon'},
                {id:14, type: 'menu',link:'dimension',label:'Bended Price',icon:'fa fa-folder sidebar-nav-icon'},
                {id:0, type: 'header', label: 'Quotation'},
                {id:7, type: 'menu',link:'quotation/new',label:'Add Quotation',icon:'fa fa-pencil sidebar-nav-icon'},
      			{id:8, type: 'menu',link:'quotation/pending',label:'Pending Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:9, type: 'menu',link:'quotation/approved',label:'Approved Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:21, type: 'menu',link:'quotation/disapproved',label:'Disapproved Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:10, type: 'menu',link:'quotation/deal',label:'Closed Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:0, type: 'header', label: 'Inventory'},
                {id:12,type: 'menu',link:'inventory',label:'Inventory',icon:'fa fa-server sidebar-nav-icon'},
                {id:16, type: 'menu',link:'purchaseorder/list',label:'Order',icon:'fa fa-pencil sidebar-nav-icon'},
                {id:11, type: 'menu',link:'purchaseorder/new',label:'Purchase Order',icon:'fa fa-pencil sidebar-nav-icon'},
                {id:17, type: 'menu',link:'delivery/list',label:'Delivery',icon:'fa fa-server sidebar-nav-icon'},
                {id:15, type: 'menu',link:'delivery/new',label:'Delivery Reciept',icon:'fa fa-server sidebar-nav-icon'},
                {id:0, type: 'header', label: 'Reports'},
                {id:18, type: 'menu',link:'reports/sales',label:'Sales',icon:'fa fa-server sidebar-nav-icon'},
                {id:19, type: 'menu',link:'reports/inventory-product',label:'Products',icon:'fa fa-server sidebar-nav-icon'},
                {id:20, type: 'menu',link:'reports/inventory-sheets',label:'Sheets',icon:'fa fa-server sidebar-nav-icon'}
                
            ];
      			
  			const salesman=[
                {id:0, type: 'header', label: 'Quotation'},
                {id:31, type: 'menu',link:'quotation/new',label:'Add Quotation',icon:'fa fa-pencil sidebar-nav-icon'},
  				{id:32, type: 'menu',link:'quotation/pendingU',label:'Pending Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:33, type: 'menu',link:'quotation/approvedU',label:'Approved Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:34, type: 'menu',link:'quotation/disapproved',label:'Disapproved Quotation',icon:'fa fa-server sidebar-nav-icon'},
                {id:35, type: 'menu',link:'quotation/dealU',label:'Closed Deal Quotation',icon:'fa fa-server sidebar-nav-icon'}
            ];
  			
  			let listItems=null;
  			if(role==="Admin"){
				 listItems = admin.map((menu) =>
                    this.generateMenu(menu)
	 			 );
			}else if(role==="Salesman"){
				 listItems = salesman.map((menu) =>
	    			this.generateMenu(menu)
	 			 );
			
			}else{

			}
    	return (
            <div id="sidebar">
                <div id="sidebar-scroll">
                    <div className="sidebar-content">
                        <a href="/" className="sidebar-brand">
                            <i className="gi gi-flash"></i><span className="sidebar-nav-mini-hide"><strong>SOLAPO</strong></span>
                        </a>
                        <div className="sidebar-section sidebar-user clearfix sidebar-nav-mini-hide">
                            <div className="sidebar-user-avatar">
                                <a href="#"><img src={this.state.path} alt="avatar"/></a>
                            </div>
                            <div className="sidebar-user-name">{this.state.user.firstname}</div>
                            <div className="sidebar-user-links">
                                <Link to={`/users/${this.state.userId}/profile`} title="Profile" data-toggle="tooltip" data-placement="bottom"><i className="gi gi-user"></i></Link>
                                <a href="#" data-toggle="tooltip" data-placement="bottom" title="Messages"><i className="gi gi-envelope"></i></a>
                                <a href="javascript:void(0)" onClick={this.logOut} data-toggle="tooltip" data-placement="bottom" title="Logout"><i className="gi gi-exit"></i></a>
                            </div>
                        </div>
                    
                        
                        <ul className="sidebar-nav">
                          {listItems}
                        </ul>
                    </div>
                </div>
            </div>
	    );
	}
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/inc/Sidebar.js